module.exports = __webpack_public_path__ + "3c896bfdad2f76fe0945fe43d776a9ab.svg";